var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormBtn',_vm._b({attrs:{"type":"submit"}},'FormBtn',{ loading: _vm.loading, disabled: _vm.disabled, id: _vm.id, label: _vm.label },false))}
var staticRenderFns = []

export { render, staticRenderFns }